import type { Experiment } from 'types';

type OffersEndParams = Pick<Experiment, 'status' | 'implementedAt'>;

/**
 * Whether marking this experiment implemented should first ask about ending it.
 *
 * Once a change is built into the site itself, a test or deployment still being served
 * applies the same change a second time on top of it. Only the transition into
 * implemented asks: unmarking is a correction, and an Ended experiment has nothing
 * left to stop.
 */
export const offersEndOnImplement = ({ status, implementedAt }: OffersEndParams): boolean =>
  !implementedAt && (status === 'Running' || status === 'Deployed');
